import { useColorScheme } from '@mui/material';
import type { ThemeMode } from './withColorSchemes';

function isThemeMode(value: string | undefined): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'system';
}

export function useThemeMode() {
  const { mode, setMode, systemMode } = useColorScheme();
  const themeMode = isThemeMode(mode) ? mode : undefined;
  const resolvedSystemMode =
    systemMode === 'light' || systemMode === 'dark' ? systemMode : undefined;

  return {
    mode: themeMode,
    setMode: (next: ThemeMode) => setMode(next),
    systemMode: resolvedSystemMode,
    resolvedMode: themeMode === 'system' ? resolvedSystemMode : themeMode,
  };
}
